<template>
    <div>
        <van-field
            readonly
            clickable
            :label="label[0]"
            class="term"
            :value="this.$store.state.commonForms[`${model.split('/')[0]}Text`]"
            placeholder="请选择婚姻状况"
            right-icon="arrow"
            @click="showMarriageTermPicker[model.split('/')[0]] = true"
        />
        <van-popup v-model="showMarriageTermPicker[model.split('/')[0]]" position="bottom">
            <van-picker
            show-toolbar
            :default-index="0"
            :columns="columnsTermMarriage"
            @cancel="showMarriageTermPicker[model.split('/')[0]] = false"
            @confirm="onMarriageConfirm"
            />
        </van-popup>
         <van-field
            readonly
            clickable
            :label="label[1]"
            class="term"
           :value="this.$store.state.commonForms[`${model.split('/')[1]}Text`]"
            :placeholder="placeholder"
            right-icon="arrow"
             @click="selectEmergencyRelation"

        />
        <van-popup  v-model="showRelationTermPicker[model.split('/')[1]]" position="bottom">
            <van-picker
            show-toolbar
            :columns="columnsTermRelation"
            @cancel="showRelationTermPicker[model.split('/')[1]] = false"
            @confirm="onRelationConfirm"

            />
        </van-popup>
    </div>
</template>

<script>
export default {
  name: 'RelatedSelect',
  props: [
    'label',
    'model',
    'placeholder',
    'columnsTerm',
  ],
  data() {
    return {
      showMarriageTermPicker: {
        [this.model.split('/')[0]]: false,
      },
      columnsTermMarriage: [],
      showRelationTermPicker: {
        [this.model.split('/')[1]]: false,
      },
      columnsTermRelation: [],
    };
  },
  created() {
    this.columnsTermRelation = JSON.parse(this.columnsTerm.split('/')[1]);
    this.columnsTermMarriage = JSON.parse(this.columnsTerm.split('/')[0]);
  },
  methods: {
    selectEmergencyRelation() {
      if (this.$store.state.commonForms.marriage !== '') {
        this.showRelationTermPicker[this.model.split('/')[1]] = true;
      } else {
        this.$notify('请先选择婚姻状况，再填写紧急联系人信息');
      }
    },
    onMarriageConfirm(value) {
      const textKey = `${this.model.split('/')[0]}Text`;
      this.$store.dispatch('commonForms/updateCommon', {
        [textKey]: value.text,
        [this.model.split('/')[0]]: value.value,
      });
      this.$store.dispatch('commonForms/updateCommon', {
        [`${this.model.split('/')[1]}Text`]: '',
        [this.model.split('/')[1]]: '',
      });
      console.log('11233', value);
      if (value.value === '20' || value.value === '22') {
        this.columnsTermRelation = [
          {
            value: '11',
            text: '配偶',
          }];
      } else if (value.value === '10' || value.value === '30' || value.value === '40') {
        // 未婚
        const listmap = JSON.parse(this.columnsTerm.split('/')[1]);
        listmap.forEach((v, index) => {
          if (v.value === '11') {
            listmap.splice(index, 1);
          }
        });
        this.columnsTermRelation = listmap;
      }
      this.showMarriageTermPicker[this.model.split('/')[0]] = false;
    },
    onRelationConfirm(value) {
      const textKey = `${this.model.split('/')[1]}Text`;
      this.$store.dispatch('commonForms/updateCommon', {
        [textKey]: value.text,
        [this.model.split('/')[1]]: value.value,
      });
      this.showRelationTermPicker[this.model.split('/')[1]] = false;
    },
  },
};
</script>
<style>
.van-field__label {
       text-align: left
   }
.term::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #DDDEE1;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
    content: ' ';
    pointer-events: none;
}
</style>
